const toolsMediaSection = document.querySelector('.o-sec.tools-media');
if(toolsMediaSection){
  const toolsMediaGridWrap = toolsMediaSection.querySelector('.c-grid-wrap');
  const toolsMediaGrid = toolsMediaSection.querySelector('.c-grid.tools-media');
  const filtersWraps = document.querySelectorAll('.c-filters-wrap');
  const filtersToggleButton = toolsMediaSection.querySelector('.c-query-controls_filters button');
  const mobileFiltersMediaQuery = typeof window !== 'undefined' && typeof window.matchMedia === 'function'
    ? window.matchMedia('(max-width: 991px)')
    : null;
  const isMobileFiltersView = () => !mobileFiltersMediaQuery || mobileFiltersMediaQuery.matches;
  const anyFiltersOverlayOpen = () => [...filtersWraps].some(wrap => wrap.classList.contains('open'));
  const openFiltersOverlay = () => {
    if (!isMobileFiltersView()) return;
    filtersWraps.forEach(wrap => wrap.classList.add('open'));
  };
  const closeFiltersOverlay = () => {
    filtersWraps.forEach(wrap => wrap.classList.remove('open'));
  };

  if (filtersWraps.length > 0 && filtersToggleButton) {
    filtersToggleButton.addEventListener('click', (event) => {      
      if (!isMobileFiltersView()) return;
      event.preventDefault();

      if (anyFiltersOverlayOpen()) {
        closeFiltersOverlay();
      } else {
        openFiltersOverlay();
      }
    });

    filtersWraps.forEach(wrap => wrap.addEventListener('click', (event) => {
      if (!isMobileFiltersView()) return;
      if (event.target === wrap) {
        closeFiltersOverlay();
      }
    }));

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && anyFiltersOverlayOpen()) {
        closeFiltersOverlay();
      }
    });

    if (mobileFiltersMediaQuery) {
      const handleFiltersBreakpointChange = (event) => {
        if (!event.matches) {
          closeFiltersOverlay();
        }
      };

      if (typeof mobileFiltersMediaQuery.addEventListener === 'function') {
        mobileFiltersMediaQuery.addEventListener('change', handleFiltersBreakpointChange);
      } else if (typeof mobileFiltersMediaQuery.addListener === 'function') {
        mobileFiltersMediaQuery.addListener(handleFiltersBreakpointChange);
      }
    }
  }

  // Function to update grid/list view - re-queries cards each time to include newly loaded ones
  function updateGridView(isGrid) {
    // Re-query cards each time to include any newly loaded cards
    const regularCards = toolsMediaGrid.querySelectorAll('.c-card.resources:not(.simple)');
    const simpleCards = toolsMediaGrid.querySelectorAll('.c-card.resources.simple');
    
    if (isGrid) {
      toolsMediaGrid.classList.add('three-up');
      toolsMediaGrid.classList.remove('one-up');

      regularCards.forEach(card => {
        card.style.display = 'block';
      });
      simpleCards.forEach(card => {
        card.style.display = 'none';
      });
    } else {
      toolsMediaGrid.classList.remove('three-up');
      toolsMediaGrid.classList.add('one-up');

      regularCards.forEach(card => {
        card.style.display = 'none';
      });
      simpleCards.forEach(card => {
        card.style.display = 'grid';
      });
    }
  }

  // HIDE SIMPLE CARDS ON INIT (default to grid view)
  updateGridView(true);
  
  // GRID/LIST VIEW SWITCHER
  const viewButtons = toolsMediaSection.querySelectorAll('.c-query-pill.layout');
  viewButtons.forEach(button => {
    button.addEventListener('click', () => {
      viewButtons.forEach(b => {
        b.classList.remove('active');
        b.setAttribute('aria-pressed', 'false');
      });
      button.classList.add('active');
      button.setAttribute('aria-pressed', 'true');

      const isGrid = button.classList.contains('grid');
      updateGridView(isGrid);
    });
  });


  // SUBTOPIC FILTER ACCORDIONS
  const topicCheckboxWrappers = toolsMediaSection.querySelectorAll('.c-topic-checkbox');
  topicCheckboxWrappers.forEach(wrapper => {
    const subtopicCheckboxWrapper = wrapper.querySelector('.c-subtopic-checkboxes');
    if(subtopicCheckboxWrapper){
      gsap.set(subtopicCheckboxWrapper, { height: 0, overflow: 'hidden' });
    
      const topicCheckbox = wrapper.querySelector(':scope > .c-checkbox-wrap input');
      topicCheckbox.addEventListener('change', () => {
        if(topicCheckbox.checked){
          gsap.to(subtopicCheckboxWrapper, { height: subtopicCheckboxWrapper.scrollHeight, duration: 0.3, ease: 'power2.inOut' });
        } else {
          gsap.to(subtopicCheckboxWrapper, { height: 0, duration: 0.3, ease: 'power2.inOut' });
          
          // When topic is unchecked, also uncheck all its subtopics
          const subtopicCheckboxes = subtopicCheckboxWrapper.querySelectorAll('input[name="subtopic"]');
          subtopicCheckboxes.forEach(subtopicCheckbox => {
            if (subtopicCheckbox.checked) {
              subtopicCheckbox.checked = false;
              // Trigger change event to update filters
              subtopicCheckbox.dispatchEvent(new Event('change', { bubbles: true }));
            }
          });
        }
      });
    }
  });


  // FILTERING SYSTEM
  const toolsMediaCards = Array.from(toolsMediaGrid.querySelectorAll('.c-card-wrap'));
  
  // Pagination settings
  const CARDS_PER_PAGE = 12;
  let cardsToShow = CARDS_PER_PAGE;
  let isLoadingPosts = false; // Flag to prevent empty state during AJAX loading
  let lastLoadWasFiltered = false; // Track if current DOM cards came from a server-filtered load
  let lastServerLoadFilters = null; // Track which filters were used for last server load
  
  // Load More button
  const loadMoreWrap = toolsMediaGridWrap?.querySelector('.c-load-more_wrap');
  const loadMoreButton = loadMoreWrap?.querySelector('button');
  
  // Selected filters pills container (not the controls one)
  const selectedFiltersContainer = toolsMediaSection.querySelector('.c-selected-filters:not(.controls)');
  
  // Map media type values from form to data attributes
  const mediaTypeMap = {
    'Video': 'video',
    'Podcast': 'podcast',
    'Publication': 'publication',
    'Blog': 'post',
    'Short Course': 'short-course'
  };

  // Map media types to their icons
  const mediaTypeIcons = {
    'Video': 'icons/tag-video',
    'Podcast': 'icons/tag-podcast',
    'Publication': 'icons/tag-publication',
    'Blog': 'icons/tag-blog',
    'Short Course': 'icons/tag-short-course'
  };

  // Map language values from form to data attributes
  const languageMap = {
    'English': 'english',
    'Spanish': 'spanish',
    'Español': 'spanish'
  };

  // Store active filters by category
  const createEmptyFiltersState = () => ({
    'media-type': [],
    'topic': [],
    'subtopic': [],
    'focus-area': [],
    'language': []
  });

  let activeFilters = createEmptyFiltersState();
  let pendingFilters = createEmptyFiltersState();

  // Get all filter inputs (exclude toggle checkboxes that don't have a name attribute)
  const filterInputs = document.querySelectorAll('.c-filters-wrap input[type="checkbox"][name]');

  const cloneFiltersState = (source) => {
    const target = createEmptyFiltersState();
    Object.keys(target).forEach(key => {
      target[key] = source[key] ? [...source[key]] : [];
    });
    return target;
  };

  const filtersMatch = (a, b) => {
    if (!a || !b) return false;
    return Object.keys(a).every(key => {
      const aVals = (a[key] || []).slice().sort();
      const bVals = (b[key] || []).slice().sort();
      return aVals.length === bVals.length && aVals.every((v, i) => v === bVals[i]);
    });
  };

  const buildFiltersStateFromInputs = () => {
    const state = createEmptyFiltersState();
    filterInputs.forEach(input => {
      if (!state.hasOwnProperty(input.name)) return;
      if (input.checked && !state[input.name].includes(input.value)) {
        state[input.name].push(input.value);
      }
    });
    return state;
  };

  const syncPendingFiltersFromInputs = () => {
    pendingFilters = buildFiltersStateFromInputs();
  };

  const applyPendingFilters = () => {
    activeFilters = cloneFiltersState(pendingFilters);
    updateFilters();
  };

  const shouldDeferFilterChange = (inputElement) => {
    if (!isMobileFiltersView()) return false;
    const wrap = inputElement.closest('.c-filters-wrap');
    if (!wrap) return false;
    return !!wrap.querySelector('.c-filters-mobile_btns');
  };

  syncPendingFiltersFromInputs();
  
  // Search input
  const searchInput = toolsMediaSection.querySelector('#search');
  let searchQuery = '';

  // Current sort method
  let currentSort = 'date';

  /**
   * Get topic/subtopic titles from IDs
   * Since the form uses IDs but cards use titles, we need to map them
   */
  function getTopicTitleById(id) {
    const checkbox = toolsMediaSection.querySelector(`#topic-${id}, #subtopic-${id}`);
    if (checkbox) {
      const label = checkbox.closest('label');
      if (label) {
        const labelText = label.querySelector('.w-form-label');
        return labelText ? labelText.textContent.trim() : null;
      }
    }
    return null;
  }

  /**
   * Get filter display name and icon
   */
  function getFilterDisplayInfo(filterName, filterValue) {
    if (filterName === 'media-type') {
      return {
        label: filterValue,
        icon: mediaTypeIcons[filterValue] || null
      };
    } else if (filterName === 'topic' || filterName === 'subtopic') {
      const title = getTopicTitleById(filterValue);
      return {
        label: title || filterValue,
        icon: null
      };
    } else if (filterName === 'focus-area' || filterName === 'language') {
      return {
        label: filterValue,
        icon: null
      };
    }
    return {
      label: filterValue,
      icon: null
    };
  }

  /**
   * Update selected filters pills display
   */
  function updateSelectedFiltersPills() {
    if (!selectedFiltersContainer) return;

    // Count total active filters
    const totalFilters = Object.values(activeFilters).reduce((sum, arr) => sum + arr.length, 0) + (searchQuery.trim() ? 1 : 0);
    
    // Hide container if no filters are active
    if (totalFilters === 0) {
      selectedFiltersContainer.style.display = 'none';
      return;
    }
    
    // Show container if filters are active
    selectedFiltersContainer.style.display = '';
    
    // Find or create the count element
    let countElement = selectedFiltersContainer.querySelector('.t-eyebrow-s');
    if (!countElement) {
      countElement = document.createElement('div');
      countElement.className = 't-eyebrow-s';
      selectedFiltersContainer.insertBefore(countElement, selectedFiltersContainer.firstChild);
    }
    countElement.textContent = `Filters (${totalFilters}):`;

    // Remove existing filter pills (keep the count element)
    const existingPills = selectedFiltersContainer.querySelectorAll('.c-query-pill:not(.layout):not(.sort)');
    existingPills.forEach(pill => pill.remove());

    // Create pills for each active filter
    Object.keys(activeFilters).forEach(filterName => {
      activeFilters[filterName].forEach(filterValue => {
        const pill = createFilterPill(filterName, filterValue);
        selectedFiltersContainer.appendChild(pill);
      });
    });

    // Add search pill if search query exists
    if (searchQuery.trim()) {
      const searchPill = createSearchPill();
      selectedFiltersContainer.appendChild(searchPill);
    }
  }

  /**
   * Create a filter pill element
   */
  function createFilterPill(filterName, filterValue) {
    const pill = document.createElement('div');
    pill.className = 'c-query-pill';
    pill.setAttribute('data-filter-name', filterName);
    pill.setAttribute('data-filter-value', filterValue);

    const info = getFilterDisplayInfo(filterName, filterValue);
    
    // Add icon if available (for media types) - clone from the checkbox label
    if (filterName === 'media-type') {
      const checkbox = toolsMediaSection.querySelector(`input[name="media-type"][value="${CSS.escape(filterValue)}"]`);
      if (checkbox) {
        const checkboxLabel = checkbox.closest('label');
        if (checkboxLabel) {
          const icon = checkboxLabel.querySelector('svg, .c-icon');
          if (icon) {
            const clonedIcon = icon.cloneNode(true);
            pill.appendChild(clonedIcon);
          }
        }
      }
    }

    // Create label
    const labelElement = document.createElement('div');
    labelElement.className = 't-body-s emphasis';
    labelElement.textContent = info.label;
    pill.appendChild(labelElement);

    // Create remove button
    const removeBtn = document.createElement('button');
    removeBtn.className = 'c-query-pill_remove';
    removeBtn.setAttribute('aria-label', `Remove ${info.label} filter`);
    
    // Add close icon (we'll use a simple × or get the icon from template)
    // For now, let's create a simple SVG close icon
    removeBtn.innerHTML = `
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" viewbox="0 0 21 21" fill="none" class="c-icon remove">
        <g clip-path="url(#clip0_3188_11123)">
          <path d="M16.625 5.60875L15.3913 4.375L10.5 9.26625L5.60875 4.375L4.375 5.60875L9.26625 10.5L4.375 15.3913L5.60875 16.625L10.5 11.7338L15.3913 16.625L16.625 15.3913L11.7338 10.5L16.625 5.60875Z" fill="currentColor"></path>
        </g>
      </svg>
    `;
    
    removeBtn.addEventListener('click', (e) => {
      e.preventDefault();
      removeFilter(filterName, filterValue);
    });

    pill.appendChild(removeBtn);
    return pill;
  }

  /**
   * Create a search pill element
   */
  function createSearchPill() {
    const pill = document.createElement('div');
    pill.className = 'c-query-pill';
    pill.setAttribute('data-filter-name', 'search');

    const label = document.createElement('div');
    label.className = 't-body-s emphasis';
    label.textContent = `Search: "${searchQuery}"`;
    pill.appendChild(label);

    const removeBtn = document.createElement('button');
    removeBtn.className = 'c-query-pill_remove';
    removeBtn.setAttribute('aria-label', 'Clear search');
    removeBtn.innerHTML = `
      <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
        <path d="M9 3L3 9M3 3L9 9" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
      </svg>
    `;
    
    removeBtn.addEventListener('click', (e) => {
      e.preventDefault();
      clearSearch();
    });

    pill.appendChild(removeBtn);
    return pill;
  }

  /**
   * Remove a filter
   */
  function removeFilter(filterName, filterValue) {
    // Remove from activeFilters
    if (activeFilters[filterName]) {
      activeFilters[filterName] = activeFilters[filterName].filter(v => v !== filterValue);
    }

    // Uncheck the corresponding checkbox
    const checkbox = toolsMediaSection.querySelector(`input[name="${filterName}"][value="${CSS.escape(filterValue)}"]`);
    if (checkbox) {
      checkbox.checked = false;
      // Trigger change event to ensure any other listeners are notified
      checkbox.dispatchEvent(new Event('change', { bubbles: true }));
    }

    // Update filters
    updateFilters();
  }

  /**
   * Clear search
   */
  function clearSearch() {
    searchQuery = '';
    if (searchInput) {
      searchInput.value = '';
    }
    updateFilters();
  }

  /**
   * Check if a card matches all active filters
   */
  function cardMatchesFilters(card) {
    // Media Type filter
    if (activeFilters['media-type'].length > 0) {
      const cardMediaType = card.getAttribute('data-media-type');
      const matchesMediaType = activeFilters['media-type'].some(filterValue => {
        const mappedType = mediaTypeMap[filterValue] || filterValue.toLowerCase();
        return cardMediaType === mappedType;
      });
      if (!matchesMediaType) return false;
    }

    // Topic filter
    if (activeFilters['topic'].length > 0) {
      const cardTopics = card.getAttribute('data-topics') || '';
      const topicIds = cardTopics.split(',').map(id => id.trim()).filter(id => id);
      const matchesTopic = activeFilters['topic'].some(topicId => {
        return topicIds.includes(topicId.toString());
      });
      if (!matchesTopic) return false;
    }

    // Subtopic filter
    if (activeFilters['subtopic'].length > 0) {
      const cardSubtopics = card.getAttribute('data-subtopics') || '';
      const subtopicIds = cardSubtopics.split(',').map(id => id.trim()).filter(id => id);
      const matchesSubtopic = activeFilters['subtopic'].some(subtopicId => {
        return subtopicIds.includes(subtopicId.toString());
      });
      if (!matchesSubtopic) return false;
    }

    // Focus Area filter
    if (activeFilters['focus-area'].length > 0) {
      const cardFocusAreas = card.getAttribute('data-focus-areas') || '';
      const focusAreaTitles = cardFocusAreas.split(',').map(title => title.trim()).filter(title => title);
      const matchesFocusArea = activeFilters['focus-area'].some(filterValue => {
        return focusAreaTitles.includes(filterValue);
      });
      if (!matchesFocusArea) return false;
    }

    // Language filter
    if (activeFilters['language'].length > 0) {
      const cardLanguages = (card.getAttribute('data-languages') || '').toLowerCase();
      const matchesLanguage = activeFilters['language'].some(filterValue => {
        const mappedLang = languageMap[filterValue] || filterValue.toLowerCase();
        return cardLanguages.includes(mappedLang);
      });
      if (!matchesLanguage) return false;
    }

    // Search filter
    if (searchQuery.trim()) {
      const cardTitle = card.querySelector('h3')?.textContent.toLowerCase() || '';
      const searchLower = searchQuery.toLowerCase();
      if (!cardTitle.includes(searchLower)) return false;
    }

    return true;
  }

  /**
   * Apply pagination to currently filtered cards
   */
  function applyFilters() {
    // Get all cards that match current filters (they should already be sorted in DOM)
    const matchingCards = toolsMediaCards.filter(card => {
      return cardMatchesFilters(card);
    });
    
    // Get all non-matching cards
    const nonMatchingCards = toolsMediaCards.filter(card => {
      return !cardMatchesFilters(card);
    });


    // Hide all non-matching cards
    nonMatchingCards.forEach(card => {
      card.style.display = 'none';
    });

    // Hide all matching cards first (we'll show the paginated ones next)
    matchingCards.forEach(card => {
      card.style.display = 'none';
    });

    // Show cards up to cardsToShow limit
    const visibleCards = matchingCards.slice(0, cardsToShow);
    visibleCards.forEach(card => {
      card.style.display = '';
    });

    // Re-apply current view state to ensure grid/list cards are shown/hidden correctly
    // This is important after AJAX loads new cards
    const gridButton = toolsMediaSection.querySelector('.c-query-pill.layout.grid');
    const isGrid = gridButton && gridButton.classList.contains('active');
    updateGridView(isGrid !== false); // Default to grid if no button state found

    // Announce results to screen readers
    const announcement = document.getElementById('filter-results-announcement');
    const loadingIndicator = document.getElementById('loading-indicator');
    if (loadingIndicator) {
      loadingIndicator.setAttribute('aria-busy', 'false');
      loadingIndicator.textContent = '';
    }
    
    if (announcement) {
      if (matchingCards.length === 0) {
        announcement.textContent = 'No resources found matching your filters.';
      } else {
        announcement.textContent = `${matchingCards.length} ${matchingCards.length === 1 ? 'result' : 'results'} found.`;
      }
    }

    // Show/hide "no results" message if needed
    // Don't show empty state if we're still loading posts (prevents premature empty state)
    let noResultsMsg = toolsMediaSection.querySelector('.c-query-empty');
    if (matchingCards.length === 0 && !isLoadingPosts) {
      if (!noResultsMsg) {
        noResultsMsg = document.createElement('div');
        noResultsMsg.className = 'c-query-empty';
        noResultsMsg.innerHTML = '<p>No resources found matching your filters.</p>';
        toolsMediaGridWrap.appendChild(noResultsMsg);
      }
      if (loadMoreWrap) loadMoreWrap.classList.add('hide');
    } else {
      if (noResultsMsg) noResultsMsg.remove();
      // Only update load more button if not loading (prevents it from showing prematurely)
      if (!isLoadingPosts) {
        updateLoadMoreButton(matchingCards.length);
      }
    }
  }

  /**
   * Update Load More button visibility
   */
  function updateLoadMoreButton(totalMatchingCards) {
    if (!loadMoreWrap) return;

    const gridWrap = toolsMediaGridWrap;
    const totalPostsAvailable = gridWrap ? parseInt(gridWrap.getAttribute('data-total-posts') || '0') : totalMatchingCards;
    const loadedPosts = gridWrap ? parseInt(gridWrap.getAttribute('data-loaded-posts') || '0') : totalMatchingCards;
    const hasMoreOnServer = gridWrap?.getAttribute('data-has-more') === 'true';

    // Show button if:
    // 1. There are more matching cards than currently shown (client-side pagination)
    // 2. Server indicates more posts available (for filtered/unfiltered queries)
    // 3. Not all posts loaded yet
    const hasMoreToShow = totalMatchingCards > cardsToShow;
    const hasMorePostsToLoad = loadedPosts < totalPostsAvailable || hasMoreOnServer;

    if (hasMoreToShow || hasMorePostsToLoad) {
      loadMoreWrap.classList.remove('hide');
    } else {
      loadMoreWrap.classList.add('hide');
    }
  }

  /**
   * Load more cards
   */
  function loadMoreCards() {
    // Get all cards that match current filters (they're already sorted in DOM)
    const matchingCards = toolsMediaCards.filter(card => {
      return cardMatchesFilters(card);
    });

    // Increase the number of cards to show
    cardsToShow += CARDS_PER_PAGE;
    
    // Show cards up to the new limit (in DOM order, which is already sorted)
    const visibleCards = matchingCards.slice(0, cardsToShow);
    visibleCards.forEach(card => {
      card.style.display = '';
    });

    // Update button visibility
    updateLoadMoreButton(matchingCards.length);
    
    // Scroll to the first newly visible card (smooth scroll)
    const previousCount = cardsToShow - CARDS_PER_PAGE;
    if (visibleCards.length > previousCount) {
      const firstNewCard = visibleCards[previousCount];
      if (firstNewCard) {
        // Small delay to ensure DOM has updated
        setTimeout(() => {
          firstNewCard.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }, 50);
      }
    }
  }

  /**
   * Sort cards array (doesn't modify DOM, just returns sorted array)
   */
  function sortCardsArray(cards) {
    const sorted = [...cards];
    
    if (currentSort === 'date') {
      sorted.sort((a, b) => {
        const dateA = new Date(a.getAttribute('data-date') || 0);
        const dateB = new Date(b.getAttribute('data-date') || 0);
        return dateB - dateA; // Newest first
      });
    } else if (currentSort === 'alpha') {
      sorted.sort((a, b) => {
        const titleA = (a.querySelector('h3')?.textContent || '').toLowerCase();
        const titleB = (b.querySelector('h3')?.textContent || '').toLowerCase();
        return titleA.localeCompare(titleB);
      });
    }
    
    return sorted;
  }

  /**
   * Rebuild DOM order with sorted cards
   */
  function rebuildDOMOrder(matchingCards, nonMatchingCards) {
    // Sort matching cards
    const sortedMatching = sortCardsArray(matchingCards);
    
    // Hide all non-matching cards before reordering
    nonMatchingCards.forEach(card => {
      card.style.display = 'none';
    });
    
    // Combine: sorted matching cards first, then non-matching
    const allCards = [...sortedMatching, ...nonMatchingCards];
    
    // Re-append in new order
    allCards.forEach(card => {
      toolsMediaGrid.appendChild(card);
    });
  }

  /**
   * Update filters and reapply
   */
  function updateFilters() {
    // Announce loading state
    const loadingIndicator = document.getElementById('loading-indicator');
    if (loadingIndicator) {
      loadingIndicator.setAttribute('aria-busy', 'true');
      loadingIndicator.textContent = 'Loading results...';
    }

    // Reset pagination when filters change
    cardsToShow = CARDS_PER_PAGE;

    // Check if we need a server-side reload instead of client-side filtering.
    // When not all posts are loaded, client-side filtering only works on the partial
    // dataset, which can miss matching results that exist on the server.
    const hasActiveFilters = Object.values(activeFilters).some(arr => arr.length > 0);
    const gridWrap = toolsMediaGridWrap;
    const hasMoreOnServer = gridWrap?.getAttribute('data-has-more') === 'true';
    const loadedPosts = parseInt(gridWrap?.getAttribute('data-loaded-posts') || '0');
    const totalPosts = parseInt(gridWrap?.getAttribute('data-total-posts') || '0');
    const notAllLoaded = hasMoreOnServer || loadedPosts < totalPosts;
    const currentFiltersMatchLastLoad = filtersMatch(activeFilters, lastServerLoadFilters);

    // Reload from server if:
    // 1. Filters changed from last server load AND there are active filters with more posts on server, OR
    // 2. Clearing filters after a server-filtered load (DOM only has filtered subset of cards)
    if (!currentFiltersMatchLastLoad && ((hasActiveFilters && notAllLoaded) || (!hasActiveFilters && lastLoadWasFiltered))) {
      lastServerLoadFilters = cloneFiltersState(activeFilters);
      lastLoadWasFiltered = hasActiveFilters;
      loadMorePostsAjax({
        useServerFilters: hasActiveFilters,
        showLoading: true,
        replaceExisting: true,
        onComplete: () => {
          updateSelectedFiltersPills();
        }
      });
      return;
    }

    // Client-side filtering (all posts loaded, or filters match what server already returned)
    const matchingCards = [];
    const nonMatchingCards = [];

    toolsMediaCards.forEach(card => {
      const matches = cardMatchesFilters(card);
      if (matches) {
        matchingCards.push(card);
      } else {
        nonMatchingCards.push(card);
      }
    });

    // Sort and rebuild DOM order
    rebuildDOMOrder(matchingCards, nonMatchingCards);

    // Apply pagination
    applyFilters();

    // Update selected filters pills
    updateSelectedFiltersPills();
  }

  /**
   * Apply filters from URL query parameters
   * Supports: ?media-type=video,podcast&filter-topic=Topic%20Name&filter-subtopic=Subtopic%20Name&focus-area=Area&language=English&search=query
   * Note: Values with spaces or special characters should be URL encoded (e.g., filter-topic=Organic%20Farming)
   * Note: Using filter-topic and filter-subtopic to avoid conflicts with WordPress post type routing
   * Note: filter-topic and filter-subtopic use encoded names (titles) like focus-area, not IDs
   */
  function applyInitialFiltersFromURL() {
    const params = new URLSearchParams(window.location.search);
    let anyApplied = false;

    // Map URL parameter names to form input names
    // Using filter-topic/filter-subtopic in URL to avoid WordPress post type conflicts
    const filterParamMap = {
      'media-type': 'media-type',
      'filter-topic': 'topic',        // URL param -> form input name
      'filter-subtopic': 'subtopic',  // URL param -> form input name
      'focus-area': 'focus-area',
      'language': 'language'
    };

    Object.keys(filterParamMap).forEach(urlParamName => {
      const formInputName = filterParamMap[urlParamName];
      const paramValue = params.get(urlParamName);
      if (!paramValue) return;

      // URLSearchParams automatically decodes values, so we can use them directly
      const requestedValues = paramValue.split(',').map(val => decodeURIComponent(val.trim())).filter(Boolean);
      if (requestedValues.length === 0) return;

      const filterInputs = Array.from(toolsMediaSection.querySelectorAll(`input[name="${formInputName}"]`));
      
      requestedValues.forEach(requestedValue => {
        // Normalize the requested value (trim and lowercase for comparison)
        const normalizedRequested = requestedValue.trim().toLowerCase();
        
        // For media-type, match by value (case-insensitive)
        // For topic/subtopic, match by label text (like focus-area) instead of ID
        // For focus-area/language, match by value (case-insensitive)
        const matchingInput = filterInputs.find(input => {
          if (formInputName === 'media-type') {
            return input.value.toLowerCase() === normalizedRequested;
          } else if (formInputName === 'topic' || formInputName === 'subtopic') {
            // Match by label text (title) instead of ID, like focus-area does
            const label = input.closest('label.w-checkbox');
            if (label) {
              const labelText = label.querySelector('.w-form-label');
              if (labelText) {
                const labelTextContent = labelText.textContent.trim().toLowerCase();
                // Case-insensitive comparison
                if (labelTextContent === normalizedRequested) {
                  return true;
                }
              }
            }
            // Fallback to ID matching for backward compatibility (if someone uses IDs)
            if (input.value === requestedValue || input.id === `${formInputName}-${requestedValue}`) {
              return true;
            }
            return false;
          } else {
            // Match by value (case-insensitive)
            return input.value.toLowerCase() === normalizedRequested;
          }
        });

        if (matchingInput) {
          anyApplied = true;
          matchingInput.checked = true;
        } else {
          // Debug: log if no match found (can be removed in production)
          console.warn(`No matching input found for ${formInputName}="${requestedValue}"`);
        }
      });
    });

    // Handle search query parameter
    const searchParam = params.get('search') || params.get('q');
    if (searchParam && searchInput) {
      searchQuery = searchParam.trim();
      searchInput.value = searchQuery;
      anyApplied = true;
    }

    // Handle sort parameter
    const sortParam = params.get('sort');
    if (sortParam && (sortParam === 'date' || sortParam === 'alpha')) {
      currentSort = sortParam;
      // Update the sort dropdown UI if needed
      const sortOptions = toolsMediaSection.querySelectorAll('.c-query-dropdown_option');
      sortOptions.forEach(option => {
        if (option.getAttribute('data-sort') === sortParam) {
          // If there's a way to mark it as active, do it here
          // This depends on your UI implementation
        }
      });
      anyApplied = true;
    }

    if (anyApplied) {
      // Sync filters from inputs immediately to preserve the state
      syncPendingFiltersFromInputs();
      // Store the pending filters state so we can restore it after loading
      window._toolsMediaPendingFiltersState = cloneFiltersState(pendingFilters);
      window._toolsMediaPendingFilters = true;
      
      // Open relevant filter accordions based on active filters
      openFilterAccordions(pendingFilters);
      
      // Update filter pills immediately so users can see active filters during loading
      // Temporarily set activeFilters to pendingFilters to show pills
      const tempActiveFilters = cloneFiltersState(activeFilters);
      activeFilters = cloneFiltersState(pendingFilters);
      updateSelectedFiltersPills();
      // Restore activeFilters (will be properly set after loading completes)
      activeFilters = tempActiveFilters;
    }

    return anyApplied;
  }

  /**
   * Open filter accordions based on active filters
   */
  function openFilterAccordions(filters) {
    // Map filter names to their accordion IDs
    const filterAccordionMap = {
      'media-type': 'filter-media-type',
      'topic': 'filter-topic',
      'subtopic': 'filter-topic', // Subtopics are under topics
      'focus-area': 'filter-focus-area',
      'language': 'filter-language'
    };

    // Open main filter accordions for any category that has active filters
    Object.keys(filters).forEach(filterName => {
      if (filters[filterName] && filters[filterName].length > 0 && filterName !== 'subtopic') {
        const accordionId = filterAccordionMap[filterName];
        if (accordionId) {
          const accordionCheckbox = toolsMediaSection.querySelector(`#${accordionId}`)?.closest('.c-filter')?.querySelector('.c-filter-checkbox');
          if (accordionCheckbox && !accordionCheckbox.checked) {
            accordionCheckbox.checked = true;
            // Trigger change event to ensure CSS updates
            accordionCheckbox.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
      }
    });

    // Always open topic accordion if topics OR subtopics are selected
    if ((filters.topic && filters.topic.length > 0) || (filters.subtopic && filters.subtopic.length > 0)) {
      const topicAccordionCheckbox = toolsMediaSection.querySelector('#filter-topic')?.closest('.c-filter')?.querySelector('.c-filter-checkbox');
      if (topicAccordionCheckbox && !topicAccordionCheckbox.checked) {
        topicAccordionCheckbox.checked = true;
        topicAccordionCheckbox.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    // If subtopics are selected, open their parent topic accordions
    // Note: filters.subtopic contains IDs (from input values), not titles
    if (filters.subtopic && filters.subtopic.length > 0) {
      filters.subtopic.forEach(subtopicId => {
        // Find the subtopic input by ID or value
        const subtopicInput = toolsMediaSection.querySelector(`input[name="subtopic"][value="${subtopicId}"], input[name="subtopic"][id="subtopic-${subtopicId}"]`);
        if (subtopicInput) {
          // Find the parent topic checkbox and ensure it's checked (opens accordion)
          const topicWrapper = subtopicInput.closest('.c-topic-checkbox');
          if (topicWrapper) {
            const topicCheckbox = topicWrapper.querySelector('input[name="topic"]');
            if (topicCheckbox) {
              // Check the topic checkbox to open the subtopic accordion
              if (!topicCheckbox.checked) {
                topicCheckbox.checked = true;
                // Trigger change event to open subtopic accordion via GSAP animation
                topicCheckbox.dispatchEvent(new Event('change', { bubbles: true }));
              }
              // Also ensure the subtopic accordion wrapper is open using GSAP
              const subtopicWrapper = topicWrapper.querySelector('.c-subtopic-checkboxes');
              if (subtopicWrapper) {
                // Check if it's already open by checking computed height
                const computedStyle = window.getComputedStyle(subtopicWrapper);
                const currentHeight = computedStyle.height;
                // If height is 0 or very small, animate it open
                if (currentHeight === '0px' || parseFloat(currentHeight) < 10) {
                  gsap.to(subtopicWrapper, { 
                    height: subtopicWrapper.scrollHeight, 
                    duration: 0.3, 
                    ease: 'power2.inOut' 
                  });
                }
              }
            }
          }
        }
      });
    }
  }

  // Listen to filter checkbox changes
  filterInputs.forEach(input => {
    input.addEventListener('change', () => {
      syncPendingFiltersFromInputs();
      if (shouldDeferFilterChange(input)) {
        return;
      }
      applyPendingFilters();
    });
  });

  const mobileApplyButtons = document.querySelectorAll('.c-filters-mobile_btn.apply-filters');
  mobileApplyButtons.forEach(button => {
    button.addEventListener('click', (event) => {
      event.preventDefault();
      syncPendingFiltersFromInputs();
      applyPendingFilters();
      closeFiltersOverlay();
    });
  });

  const mobileClearButtons = document.querySelectorAll('.c-filters-mobile_btn.clear-all');
  mobileClearButtons.forEach(button => {
    button.addEventListener('click', (event) => {
      event.preventDefault();
      filterInputs.forEach(input => {
        input.checked = false;
      });
      syncPendingFiltersFromInputs();
      applyPendingFilters();
      closeFiltersOverlay();
    });
  });

  // Listen to search input
  if (searchInput) {
    let searchTimeout;
    searchInput.addEventListener('input', (e) => {
      searchQuery = e.target.value;
      clearTimeout(searchTimeout);
      searchTimeout = setTimeout(() => {
        updateFilters();
      }, 300); // Debounce search
    });

    // Prevent form submission
    const searchForm = searchInput.closest('.w-form');
    if (searchForm) {
      searchForm.addEventListener('submit', (e) => {
        e.preventDefault();
        updateFilters();
      });
    }
  }

  // Listen to sort dropdown changes
  const sortOptions = toolsMediaSection.querySelectorAll('.c-query-dropdown_option');
  sortOptions.forEach(option => {
    option.addEventListener('click', () => {
      currentSort = option.getAttribute('data-sort');
      // Reset pagination and reapply filters with new sort
      cardsToShow = CARDS_PER_PAGE;
      
      // Get matching and non-matching cards
      const matchingCards = toolsMediaCards.filter(card => cardMatchesFilters(card));
      const nonMatchingCards = toolsMediaCards.filter(card => !cardMatchesFilters(card));
      
      // Rebuild DOM with new sort order
      rebuildDOMOrder(matchingCards, nonMatchingCards);
      
      // Apply pagination
      applyFilters();
    });
  });

  // Load More button click handler
  if (loadMoreButton) {
    loadMoreButton.addEventListener('click', (e) => {
      e.preventDefault();

      const gridWrap = toolsMediaGridWrap;
      const loadedPosts = parseInt(gridWrap?.getAttribute('data-loaded-posts') || '0');
      const totalPosts = parseInt(gridWrap?.getAttribute('data-total-posts') || '0');
      const hasMoreOnServer = gridWrap?.getAttribute('data-has-more') === 'true';

      // Check if we have more matching cards already loaded to show
      const matchingCards = toolsMediaCards.filter(card => cardMatchesFilters(card));
      const hasMoreLoadedCards = matchingCards.length > cardsToShow;

      if (hasMoreLoadedCards) {
        // Show more from already-loaded cards (client-side pagination)
        loadMoreCards();
      } else if (hasMoreOnServer || loadedPosts < totalPosts) {
        // Need to fetch more from server
        loadMoreButton.disabled = true;
        const buttonTextEl = loadMoreButton.querySelector('.t-body-s');
        if (buttonTextEl) buttonTextEl.textContent = 'Loading...';

        // Check if any filters are active
        const hasActiveFilters = Object.values(activeFilters).some(arr => arr.length > 0);

        loadMorePostsAjax({
          useServerFilters: hasActiveFilters,
          showLoading: false,
          onComplete: () => {
            loadMoreButton.disabled = false;
            if (buttonTextEl) buttonTextEl.textContent = 'Load More';
            // Increase cards to show after loading
            cardsToShow += CARDS_PER_PAGE;
            applyFilters();
          }
        });
      }
    });
  }

  // Check for URL filters FIRST, before rendering cards
  const hasURLFilters = new URLSearchParams(window.location.search).has('media-type') || 
                        new URLSearchParams(window.location.search).has('filter-topic') ||
                        new URLSearchParams(window.location.search).has('filter-subtopic') ||
                        new URLSearchParams(window.location.search).has('focus-area') ||
                        new URLSearchParams(window.location.search).has('language') ||
                        new URLSearchParams(window.location.search).has('search') ||
                        new URLSearchParams(window.location.search).has('q');

  // Initialize: sort all cards and show initial pagination on page load
  // First, separate all cards (initially all match since no filters are active)
  const allMatchingCards = [...toolsMediaCards];
  const sortedCards = sortCardsArray(allMatchingCards);
  
  // Rebuild DOM with sorted order
  sortedCards.forEach(card => {
    toolsMediaGrid.appendChild(card);
  });
  
  // If URL filters are present, hide cards immediately and show loading
  if (hasURLFilters) {
    isLoadingPosts = true;
    toolsMediaCards.forEach(card => {
      card.style.display = 'none';
    });
    const existingNoResults = toolsMediaSection.querySelector('.c-query-empty');
    if (existingNoResults) existingNoResults.remove();
    if (loadMoreWrap) loadMoreWrap.classList.add('hide');
    showLoadingState();
  }
  
  // Apply initial pagination
  const urlFiltersApplied = applyInitialFiltersFromURL();
  if (!urlFiltersApplied) {
    applyFilters();
    
    // Initialize selected filters pills (will be empty initially)
    updateSelectedFiltersPills();
    
    // Load remaining posts without showing loading state (normal page load)
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => loadRemainingPosts(true));
    } else {
      loadRemainingPosts(true);
    }
  } else {
    // URL filters were applied - wait for posts to load before showing results
    // Loading state already shown above if hasURLFilters
    if (!hasURLFilters) {
      showLoadingState();
    }
    
    // Load remaining posts first, then apply filters
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => loadRemainingPosts(false));
    } else {
      loadRemainingPosts(false);
    }
  }
  
  // Show load more button initially if there are more posts available (only if no URL filters)
  if (!urlFiltersApplied) {
    const initialMatchingCards = toolsMediaCards.filter(card => cardMatchesFilters(card));
    updateLoadMoreButton(initialMatchingCards.length);
  }

  /**
   * Show loading state
   */
  function showLoadingState() {
    isLoadingPosts = true; // Set flag to prevent empty state
    
    // Add loading cursor to body
    document.body.style.cursor = 'wait';
    toolsMediaSection.style.cursor = 'wait';
    
    // Hide empty state and load more button while loading
    const noResultsMsg = toolsMediaSection.querySelector('.c-query-empty');
    if (noResultsMsg) {
      noResultsMsg.style.display = 'none';
      noResultsMsg.remove(); // Actually remove it, not just hide
    }
    if (loadMoreWrap) loadMoreWrap.classList.add('hide');
    
    // Hide all cards temporarily while loading
    toolsMediaCards.forEach(card => {
      card.style.display = 'none';
    });
    
    // Show loading indicator with pulsating animation
    const loadingIndicator = document.getElementById('loading-indicator');
    if (loadingIndicator) {
      loadingIndicator.setAttribute('aria-busy', 'true');
      loadingIndicator.textContent = 'Loading resources...';
      // Make it visible (remove sr-only class)
      loadingIndicator.classList.remove('sr-only');
      // Add pulsating animation class
      loadingIndicator.classList.add('loading-pulse');
      
      // Add CSS animation if not already added
      if (!document.getElementById('loading-pulse-styles')) {
        const style = document.createElement('style');
        style.id = 'loading-pulse-styles';
        style.textContent = `
          #loading-indicator.loading-pulse {
            animation: pulse-opacity 1.5s ease-in-out infinite;
            display: block;
          }
          @keyframes pulse-opacity {
            0%, 100% {
              opacity: 1;
            }
            50% {
              opacity: 0.4;
            }
          }
        `;
        document.head.appendChild(style);
      }
    }
    
    // Also update announcement for screen readers
    const announcement = document.getElementById('filter-results-announcement');
    if (announcement) {
      announcement.textContent = 'Loading filtered resources...';
    }
    
    // Note: Filter pills remain visible during loading (they're updated separately)
  }

  /**
   * Hide loading state
   */
  function hideLoadingState() {
    isLoadingPosts = false; // Clear flag to allow empty state if needed
    
    // Remove loading cursor
    document.body.style.cursor = '';
    toolsMediaSection.style.cursor = '';
    
    const loadingIndicator = document.getElementById('loading-indicator');
    if (loadingIndicator) {
      loadingIndicator.setAttribute('aria-busy', 'false');
      loadingIndicator.textContent = '';
      // Hide it again and remove animation
      loadingIndicator.classList.add('sr-only');
      loadingIndicator.classList.remove('loading-pulse');
    }
  }

  /**
   * Load more posts via AJAX with optional server-side filtering
   * @param {Object} options - Configuration options
   * @param {boolean} options.useServerFilters - If true, pass filters to server for filtered query
   * @param {boolean} options.showLoading - If true, show loading state
   * @param {boolean} options.replaceExisting - If true, clear existing cards and start fresh (for initial URL filter load)
   * @param {Function} options.onComplete - Callback when loading completes
   */
  function loadMorePostsAjax(options = {}) {
    const { useServerFilters = false, showLoading = false, replaceExisting = false, onComplete = null } = options;

    const gridWrap = toolsMediaGridWrap;
    if (!gridWrap || !toolsMediaGrid || !window.ncatAjax) {
      if (onComplete) onComplete();
      return;
    }

    // When replacing existing cards (initial URL filter load), start from offset 0
    // Otherwise, for filtered queries use the count of filtered cards loaded so far
    // For unfiltered queries, use the total loaded posts count
    let offset;
    if (replaceExisting) {
      offset = 0;
    } else if (useServerFilters) {
      // Count only the cards that were loaded via filtered AJAX (tracked separately)
      offset = parseInt(gridWrap.getAttribute('data-filtered-loaded') || '0');
    } else {
      offset = parseInt(gridWrap.getAttribute('data-loaded-posts') || '0');
    }

    if (showLoading) {
      showLoadingState();
    }

    const formData = new FormData();
    formData.append('action', 'ncat_load_remaining_resources');
    formData.append('nonce', window.ncatAjax.nonce);
    formData.append('offset', offset);
    formData.append('posts_per_page', CARDS_PER_PAGE);

    // Pass filters to server if requested (for URL filter scenarios)
    if (useServerFilters) {
      const filtersToUse = window._toolsMediaPendingFiltersState || activeFilters;

      if (filtersToUse['media-type'] && filtersToUse['media-type'].length > 0) {
        filtersToUse['media-type'].forEach(val => formData.append('media_types[]', val));
      }
      if (filtersToUse['topic'] && filtersToUse['topic'].length > 0) {
        filtersToUse['topic'].forEach(val => formData.append('topics[]', val));
      }
      if (filtersToUse['subtopic'] && filtersToUse['subtopic'].length > 0) {
        filtersToUse['subtopic'].forEach(val => formData.append('subtopics[]', val));
      }
      if (filtersToUse['focus-area'] && filtersToUse['focus-area'].length > 0) {
        filtersToUse['focus-area'].forEach(val => formData.append('focus_areas[]', val));
      }
    }

    fetch(window.ncatAjax.ajaxurl, {
      method: 'POST',
      body: formData
    })
    .then(response => response.json())
    .then(data => {
      if (data.success && data.data) {
        const { html, count, total, has_more } = data.data;

        // If replacing existing cards, clear the grid and array first
        if (replaceExisting) {
          toolsMediaCards.length = 0; // Clear array
          toolsMediaGrid.innerHTML = ''; // Clear DOM
          gridWrap.setAttribute('data-filtered-loaded', '0');
        }

        if (html) {
          const tempDiv = document.createElement('div');
          tempDiv.innerHTML = html;
          const newCards = Array.from(tempDiv.querySelectorAll('.c-card-wrap'));

          if (newCards.length > 0) {
            // Append new cards to grid and array
            newCards.forEach(card => {
              toolsMediaGrid.appendChild(card);
              toolsMediaCards.push(card);
            });

            // Track filtered cards loaded separately
            if (useServerFilters) {
              const currentFiltered = parseInt(gridWrap.getAttribute('data-filtered-loaded') || '0');
              gridWrap.setAttribute('data-filtered-loaded', currentFiltered + count);
            }

            // Update loaded count
            gridWrap.setAttribute('data-loaded-posts', toolsMediaCards.length);

            // Update total from server response to keep counts accurate
            if (total !== undefined) {
              gridWrap.setAttribute('data-total-posts', total);
            }
          }
        }

        // Update has_more state for button visibility
        gridWrap.setAttribute('data-has-more', has_more ? 'true' : 'false');

        // Re-sort and apply filters
        const allCards = [...toolsMediaCards];
        const sortedAllCards = sortCardsArray(allCards);

        // Rebuild DOM order
        sortedAllCards.forEach(card => {
          toolsMediaGrid.appendChild(card);
        });

        // Apply pending filters if this was a URL-filtered load
        if (useServerFilters && window._toolsMediaPendingFilters) {
          if (window._toolsMediaPendingFiltersState) {
            pendingFilters = cloneFiltersState(window._toolsMediaPendingFiltersState);
            Object.keys(pendingFilters).forEach(filterName => {
              pendingFilters[filterName].forEach(filterValue => {
                const inputs = Array.from(toolsMediaSection.querySelectorAll(`input[name="${filterName}"]`));
                inputs.forEach(input => {
                  if (input.value === filterValue || input.value.toString() === filterValue.toString()) {
                    input.checked = true;
                  }
                });
              });
            });
            openFilterAccordions(pendingFilters);
            // Track that these filters were used for the server load so that
            // the subsequent applyPendingFilters → updateFilters call knows
            // the current cards already match and doesn't trigger another reload
            lastServerLoadFilters = cloneFiltersState(window._toolsMediaPendingFiltersState);
            lastLoadWasFiltered = true;
          }
          isLoadingPosts = false;
          applyPendingFilters();
          window._toolsMediaPendingFilters = false;
          window._toolsMediaPendingFiltersState = null;
        } else {
          isLoadingPosts = false;
          applyFilters();
        }

        // Update load more button based on server response
        if (loadMoreWrap) {
          if (has_more) {
            loadMoreWrap.classList.remove('hide');
          } else {
            loadMoreWrap.classList.add('hide');
          }
        }
      }

      if (showLoading) hideLoadingState();
      if (onComplete) onComplete();
    })
    .catch(error => {
      console.error('Error loading posts:', error);
      if (showLoading) hideLoadingState();
      if (onComplete) onComplete();
    });
  }

  /**
   * Initial load function - handles URL filters by replacing unfiltered content
   */
  function loadRemainingPosts(skipLoadingState = false) {
    // For URL filters, use server-side filtering and replace the initial unfiltered cards
    if (window._toolsMediaPendingFilters) {
      loadMorePostsAjax({
        useServerFilters: true,
        showLoading: !skipLoadingState,
        replaceExisting: true // Start fresh with filtered results
      });
    } else {
      // For normal page load, just apply filters to existing cards
      // Don't auto-load more - let user click "Load More"
      isLoadingPosts = false;
      applyFilters();
      if (!skipLoadingState) hideLoadingState();
    }
  }

  // =====================================================
  // STATE PERSISTENCE FOR BACK/FORWARD NAVIGATION
  // =====================================================

  const STORAGE_KEY = 'toolsMediaState';

  /**
   * Save current state to sessionStorage
   */
  function saveState() {
    const gridWrap = toolsMediaGridWrap;
    if (!gridWrap) return;

    const state = {
      scrollY: window.scrollY,
      cardsToShow: cardsToShow,
      loadedPosts: parseInt(gridWrap.getAttribute('data-loaded-posts') || '0'),
      filteredLoaded: parseInt(gridWrap.getAttribute('data-filtered-loaded') || '0'),
      hasMore: gridWrap.getAttribute('data-has-more'),
      activeFilters: cloneFiltersState(activeFilters),
      currentSort: currentSort,
      timestamp: Date.now()
    };

    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(state));
    } catch (e) {
      console.warn('Could not save state to sessionStorage:', e);
    }
  }

  /**
   * Restore state from sessionStorage
   * @returns {boolean} Whether state was restored
   */
  function restoreState() {
    try {
      const savedState = sessionStorage.getItem(STORAGE_KEY);
      if (!savedState) return false;

      const state = JSON.parse(savedState);

      // Only restore if state is less than 30 minutes old
      if (Date.now() - state.timestamp > 30 * 60 * 1000) {
        sessionStorage.removeItem(STORAGE_KEY);
        return false;
      }

      // Clear the saved state immediately to prevent re-restoring on refresh
      sessionStorage.removeItem(STORAGE_KEY);

      return state;
    } catch (e) {
      console.warn('Could not restore state from sessionStorage:', e);
      return false;
    }
  }

  /**
   * Load posts until we reach the target count, then scroll to position
   */
  function restoreToState(state) {
    const gridWrap = toolsMediaGridWrap;
    if (!gridWrap) return;

    const targetLoaded = state.loadedPosts;
    const currentLoaded = parseInt(gridWrap.getAttribute('data-loaded-posts') || '0');

    // Restore cardsToShow
    cardsToShow = state.cardsToShow || CARDS_PER_PAGE;

    // Restore sort
    if (state.currentSort) {
      currentSort = state.currentSort;
    }

    // Check if we need to load more posts
    if (targetLoaded > currentLoaded && window.ncatAjax) {
      showLoadingState();

      // Calculate how many posts we need to load
      const postsNeeded = targetLoaded - currentLoaded;

      // Load posts in one request
      const formData = new FormData();
      formData.append('action', 'ncat_load_remaining_resources');
      formData.append('nonce', window.ncatAjax.nonce);
      formData.append('offset', currentLoaded);
      formData.append('posts_per_page', postsNeeded);

      fetch(window.ncatAjax.ajaxurl, {
        method: 'POST',
        body: formData
      })
      .then(response => response.json())
      .then(data => {
        if (data.success && data.data && data.data.html) {
          const tempDiv = document.createElement('div');
          tempDiv.innerHTML = data.data.html;
          const newCards = Array.from(tempDiv.querySelectorAll('.c-card-wrap'));

          newCards.forEach(card => {
            toolsMediaGrid.appendChild(card);
            toolsMediaCards.push(card);
          });

          gridWrap.setAttribute('data-loaded-posts', targetLoaded);
          gridWrap.setAttribute('data-has-more', data.data.has_more ? 'true' : 'false');

          // Re-sort all cards
          const allCards = [...toolsMediaCards];
          const sortedAllCards = sortCardsArray(allCards);
          sortedAllCards.forEach(card => {
            toolsMediaGrid.appendChild(card);
          });
        }

        hideLoadingState();
        applyFilters();

        // Scroll to saved position after a brief delay for DOM to settle
        requestAnimationFrame(() => {
          setTimeout(() => {
            window.scrollTo(0, state.scrollY);
          }, 100);
        });
      })
      .catch(error => {
        console.error('Error restoring state:', error);
        hideLoadingState();
        applyFilters();
      });
    } else {
      // No additional posts needed, just apply filters and scroll
      applyFilters();
      requestAnimationFrame(() => {
        setTimeout(() => {
          window.scrollTo(0, state.scrollY);
        }, 100);
      });
    }
  }

  // Save state when clicking on any link within resource cards
  toolsMediaGrid.addEventListener('click', (e) => {
    const link = e.target.closest('a');
    if (link && link.href && !link.href.startsWith('#')) {
      saveState();
    }
  });

  // Also save state on beforeunload as a fallback
  window.addEventListener('beforeunload', saveState);

  // Check for saved state on page load and restore if found
  // Only do this if there are no URL filters (URL filters take precedence)
  if (!hasURLFilters) {
    const savedState = restoreState();
    if (savedState) {
      // Defer restoration until after initial setup
      requestAnimationFrame(() => {
        restoreToState(savedState);
      });
    }
  }
}